import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import request from "@/lib/api/handler";

interface OpportunitySkillsProps {
  title: string;
  deliverables?: string;
  goals?: string;
}

export const useOpportunitiesSkillsQuery = (
  context: OpportunitySkillsProps,
) => {
  const { getAccessTokenSilently } = useAuth0();

  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.companyOpportunitySkills(context.title),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!context.title,
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const { skills } = await request<{ skills: string[] }>({
        method: "POST",
        path: "/api/jobOpening/skills_list",
        token,
        body: JSON.stringify(context),
      });

      return skills;
    },
  });

  return {
    skillsLoading: isLoading,
    skills: data ?? null,
    skillsError: error ?? null,
  };
};
